import { render, staticRenderFns } from "./SchoolJob.vue?vue&type=template&id=853181f2"
import script from "./SchoolJob.vue?vue&type=script&lang=js"
export * from "./SchoolJob.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports